import type { AnswerValue, Answers, Question, Section } from './types';

// Mirrors the strict checks in server/src/domain/answers.ts so clients get instant feedback.
// The server remains the source of truth.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const PHONE_RE = /^\+?[\d\s().-]{5,25}$/;

export function isEmptyAnswer(v: AnswerValue | undefined): boolean {
  return (
    v === undefined ||
    (typeof v === 'string' && v.trim() === '') ||
    (Array.isArray(v) && v.length === 0)
  );
}

export function validateQuestion(q: Question, value: AnswerValue | undefined): string | undefined {
  if (isEmptyAnswer(value)) return q.required ? 'This question is required' : undefined;
  const s = typeof value === 'string' ? value.trim() : '';
  if (q.type === 'email' && !EMAIL_RE.test(s)) return 'Enter a valid email address';
  if (q.type === 'phone' && !PHONE_RE.test(s)) return 'Enter a valid phone number';
  if (q.type === 'number' && !Number.isFinite(Number(value))) return 'Enter a number';
  return undefined;
}

export function validateSection(section: Section, answers: Answers): Record<string, string> {
  const errors: Record<string, string> = {};
  for (const q of section.questions) {
    const err = validateQuestion(q, answers[q.id]);
    if (err) errors[q.id] = err;
  }
  return errors;
}

export function countAnswered(sections: Section[], answers: Answers): number {
  return sections.reduce(
    (n, s) => n + s.questions.filter((q) => !isEmptyAnswer(answers[q.id])).length,
    0,
  );
}
